import * as React from 'react';

function Splash() {
    React.useEffect(() => {
        const container = document.getElementById('MainBody');
        if (container) container.style.backgroundColor = '#ffffffff';
    },[])
    

    return(
        <div className='ms-u-textAlignCenter'>
            
        </div>
    );
}

export default React.memo(Splash);
